// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/instrument-spin-recovery.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/instrument-spin-recovery/instrument-spin-recovery.js';

mount([g0]);
